export default __webpack_public_path__ + "static/media/emptyStateHJ.a13ada3d.png";